export const SALON_DASHBOARD_POLL_MS = 8000;
